// extracted by mini-css-extract-plugin
export var actionIcon = "_tq-0";